module.exports = __webpack_public_path__ + "media/images/articles/interview/thumb-7b8b5c1e3889492040eed477a3101530.png";